'use client';

import { SyntheticEvent } from 'react';
import { useSetAtom } from 'jotai';
import { CtaComponent } from '@sapientpro/sapientpro-data-models';
import Button, { ButtonVariants } from '../Button';
import contactModalTriggerButton from '../../store/contactForm';
import styles from './CalculatorCTA.module.scss';

const CTAButton = ({ route, ctaButton }: { route: CtaComponent['route']; ctaButton: CtaComponent['ctaButton'] }) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const handleGetExpertAdviceClick = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | ai development services page cta section`);
  };

  return (
    <Button
      variant={ButtonVariants.PRIMARY}
      className={styles.calculatorCTA__button}
      {...(route ? { link: route } : { onClick: handleGetExpertAdviceClick })}
    >
      {ctaButton}
    </Button>
  );
};

export default CTAButton;
